import { render, staticRenderFns } from "./EditBreadFieldCard.vue?vue&type=template&id=70ce4030"
import script from "./EditBreadFieldCard.vue?vue&type=script&lang=js"
export * from "./EditBreadFieldCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports